var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.573 10.4851C14.5016 10.4851 14.4302 10.459 14.3745 10.4062L11.0348 7.27307C10.9181 7.16395 10.9123 6.97996 11.022 6.8633C11.1317 6.74547 11.3145 6.74025 11.4324 6.85053L14.7721 9.98364C14.8888 10.0928 14.8946 10.2767 14.7849 10.3934C14.7274 10.4544 14.6508 10.4851 14.573 10.4851Z",
    fill: "#956D84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42526 10.4857C3.34807 10.4857 3.27087 10.4549 3.21341 10.394C3.10371 10.2773 3.10952 10.0933 3.22618 9.9842L6.56708 6.85109C6.68433 6.74197 6.86832 6.74661 6.97744 6.86386C7.08714 6.98052 7.08133 7.16452 6.96467 7.27363L3.62377 10.4067C3.56805 10.4596 3.49666 10.4857 3.42526 10.4857Z",
    fill: "#956D84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5489 13.3981H1.45105C0.651232 13.3981 0 12.7475 0 11.9471V2.05264C0 1.25224 0.651232 0.25 1.45105 0.25H16.5489C17.3488 0.25 18 1.25224 18 2.05264V11.9471C18 12.7475 17.3488 13.3981 16.5489 13.3981ZM1.45105 1.37503C0.971043 1.37503 1.125 1.57263 1.125 2.05264V12.0625C1.125 12.5425 0.971043 12.2342 1.45105 12.2342H16.5489C17.029 12.2342 16.875 12.4271 16.875 11.9471V1.9375C16.875 1.45749 17.029 1.37503 16.5489 1.37503H1.45105Z",
    fill: "#956D84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00066 8.45819C8.61468 8.45819 8.2287 8.32992 7.935 8.07396L0.482406 1.57266C0.361678 1.46761 0.348909 1.2842 0.453965 1.16289C0.560182 1.04216 1.0049 0.708563 1.12563 0.812458L8.43813 6.99996C8.80901 7.32326 9.19282 7.32326 9.56313 6.99996L16.8756 0.812439C16.6235 0.479422 17.4307 1.05203 17.5375 1.17334C17.6425 1.29464 17.6304 1.47748 17.5096 1.58311L10.0663 8.07338C9.77204 8.32992 9.38664 8.45819 9.00066 8.45819Z",
    fill: "#956D84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d61424da74bdee98407ac075605e0b84.svg";
export { ForwardRef as ReactComponent };